module.exports = __webpack_public_path__ + "static/media/clover-mini.aa0d41f2.jpg";